<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 24 24"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6.75824 17.2431L12.0009 12.0005M12.0009 12.0005L17.2435 6.75781M12.0009 12.0005L6.75824 6.75781M12.0009 12.0005L17.2435 17.2431"
      :stroke="fill"
      stroke-linecap="round"
      stroke-linejoin="round"
      :stroke-width="strokeWidth"
    />
  </svg>
</template>

<script>
export default {
  name: 'Close',
  props: {
    width: {
      type: String,
      required: false,
      default: '24'
    },
    height: {
      type: String,
      required: false,
      default: '24'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
    strokeWidth: {
      type: String,
      required: false,
      default: '2'
    },
  },
};

</script>
